import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import { Form, Button, Table, InputGroup, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { adminInstance } from "../../services/axiosInstance";

function ServiceRequestApprovalListPage() {
    const [request, setRequest] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [data, setdata] = useState([]);

    const SERVICE_TYPES = {
        DEMO: { label: 'Demo Request', color: 'primary' },
        WARRANTY: { label: 'Warranty Request', color: 'success' },
        SERVICE: { label: 'Service Invoice Request', color: 'info' }
    };

    const STATUS_CONFIG = {
        Open: { label: 'Open', color: 'warning' },
        "Pending With Manager": { label: 'Pending Approval', color: 'warning' },
        "Pending With MD": { label: 'Approved', color: 'warning' },
        "Pending With Commercial": { label: 'Rejected', color: 'warning' },
        Completed: { label: 'Completed', color: 'success' }
    };

    const getStatusBadge = (status) => {
        const config = STATUS_CONFIG[status] || { label: status, color: 'secondary' };
        return <Badge bg={config.color}>{config.label}</Badge>;
    };
       
    useEffect(() => {
        fetchRequest();        
    }, []);

    const fetchRequest = async () => {
        try {
            debugger;
            const response = await adminInstance.get("servicerequest/GetPendingApprovals");
            setRequest(response.data || []);
            setdata(response.data || []);
        } catch (error) {
            console.error('Error fetching orders:', error.message);
            debugger;
        } finally {
            console.log('Fetch process completed.');
        }
    };

    const navigate = useNavigate();    

    const handleView = (reqId) => {
        navigate(`/ServiceRequestApproverDetail/${reqId}`);
    }
    
    const filteredData = data
    .filter(spare =>
        spare.EMP_NAME?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      spare.CUS_NAME?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      spare.ITEM_CODE?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      spare.ITEM_DESC?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      spare.REQ_STATUS?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      spare.REQ_DATE?.toLowerCase().includes(searchTerm.toLowerCase()) 
    );

    return (
        <>

            <>
                <div className="card aon-card">
                    <div className="card-header aon-card-header">
                        <div className="d-flex justify-content-between align-items-center">
                        <h4>
                                Service Request Approval List
                        </h4>                        
                    </div>
                    </div>
                    <div className="card-body aon-card-body">
                        {
                            <div className="sf-bs-data-table">
                                <div className="table-responsive">
                                    {/* Not  */}
                                    <table className="table table-striped table-bordered example-dt-table aon-booking-table responsive" style={{ width: '100%'}}>
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Date</th>
                                                <th>Type</th>
                                                <th>Employee</th>                                                
                                                <th>Customer</th>
                                                <th>Item</th>
                                                <th>Total Amount</th>
                                                <th>Status</th>
                                                <th>Action</th>                                              
                                            </tr>
                                        </thead>
                                        <tbody>
                                        <tr >
                                            <td colSpan={10}>
                                            <InputGroup className="mb-3">
                                            <Form.Control
                                                placeholder="Search request..."
                                                value={searchTerm}
                                                onChange={e => setSearchTerm(e.target.value)}
                                            />
                                            </InputGroup>
                                            </td>
                                        </tr>
                                            {
                                                filteredData?.map((emp, index) => {
                                                    return (
                                                        <tr key={uuidv4()}>
                                                            <td>{emp.ID}</td>                                                            
                                                            <td>{new Date(emp.REQ_DATE).toLocaleDateString('en-GB', {
                                                                day: '2-digit',
                                                                month: 'short',
                                                                year: 'numeric'
                                                                })}</td>                                                                                                                  
                                                            <td><Badge
                                                                bg={SERVICE_TYPES[emp.REQ_TYPE]?.color || 'primary'}
                                                                className="px-3 py-2"
                                                            >
                                                                {SERVICE_TYPES[emp.REQ_TYPE]?.label}
                                                            </Badge></td>                                                            
                                                            <td>{emp.EMP_NAME}</td>                                                            
                                                            <td>{emp.CUS_NAME}</td>
                                                            <td>{emp.ITEM_CODE + " - " + emp.ITEM_DESC}</td>
                                                            <td><strong>₹{emp.TOTAL_AMOUNT}</strong></td>
                                                            <td>{ getStatusBadge(emp.REQ_STATUS)}</td>
                                                            <td>
                                                                <button className="admin-button wid-200" onClick={() => handleView(emp.ID)} style={{marginRight:20}}>View</button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                          }                                            
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </>

        </>
    );
}

export default ServiceRequestApprovalListPage;
